import React, {Component} from 'react';
import TimeGrid from './TimeGrid';
import moment from 'moment';
import AppCalendarCell from './Appointments/AppCalendarCell';
import Appointment, { ParseConflicts } from '../api/Appointment';
import AppointmentService from '../api/services/AppointmentService';
import ClinicService from '../api/services/ClinicService';
import { NotificationManager } from 'react-notifications';
import CalendarAppointment from "./Appointments/CalendarAppointment";
import ExtAppService, {ExtAppToIntApp} from "../api/services/ExtAppService";
import BCCalendarAppointmentCell from "../components/biopedConnect/BCCalendarAppointmentCell";


export default class CalendarWeekView extends TimeGrid{
    gridActiveMatrix = [];
    constructor(props){
        super(props);
        this.getDateFromPos = this.getDateFromPos.bind(this);
        this.getPosFromDate = this.getPosFromDate.bind(this);
        this.handleUpdateApp = this.handleUpdateApp.bind(this);

    }
    getColumnHeaders(){

        let weekRange = moment(this.props.date);
        let today = moment().format('YYYY/M/D');
        let days = [];

        this.gridActiveMatrix = []

        for(let i=0; i < 7; i++){
            weekRange.day(i)
            let isToday = (today == weekRange.format('YYYY/M/D'));

            this.gridActiveMatrix.push(this.calcMatrix(weekRange));

            days.push(<div key={i} className={isToday ? "today" : ""}>{weekRange.format("ddd D")}</div>);
            //setDate(weekStart.getDate() + 1);
        }



        return days;
    }

    calcMatrix(date){
        const doctor = ClinicService.GetDrById(this.props.doctorId);
        const schedule = doctor.settings.schedule.cache;
        let nDate = moment(date).clone();
        let hours = schedule.getDateHours(nDate);
        let o = [];
        if(hours){
            let startTime = moment(hours[0], 'h:mm a');
            let endTime = moment(hours[1], 'h:mm a');
            let rowStart = this.getRowFromTime(startTime);
            let rowEnd = this.getRowFromTime(endTime);


            return [rowStart, rowEnd];

            /*for(let i=rowStart; i < rowEnd; i++){
                o.push(i);
            }*/
        }

        return o;

    }



    getDateFromPos(col, row){
        let date = moment(this.props.date);
        let time = this.getTimeFromRow(row);
        date.day(parseInt(col/this.colSegs, 10));

        date.hour(time.hour());
        date.minutes(time.minute());
        date.second(0);
        return date;
    }

    getPosFromDate(date){
        date = moment(date);
        let col = date.day() * this.colSegs;
        let row = this.getRowFromTime(date);
        return [row, col];
    }

    extractStackedApps(){
        let apps = this.getAppointments();
        //console.log("App Conflicts:",  Appointment.FindConflicts(apps));
        let stacks = {};
        let o = [];

        for(let i=0; i < apps.length; i++){
            let app = apps[i];
            let id = Appointment.FormatAppDateTime(app);
            if(stacks[id] == null){
                stacks[id] = [];
            }
            stacks[id].push(app);
        }

        for(let p in stacks){
            o.push(stacks[p])
        }

        return o;

    }

    getAppointments(){
        return this.props.appointments.filter( app => app.userId == this.props.doctorId);
    }



    getItems(){
        let apps = Appointment.FindConflicts(this.getAppointments());// this.extractStackedApps();// this.props.appointments.filter( app => app.userId == this.props.doctorId);
        // console.log("Conflict Apps:", apps);
        let items = [];

        for(let i=0; i < apps.length; i++){
            let app = apps[i];//[0];
            let itemOffset = ParseConflicts(app);
            //console.log("ParseConflicts:", itemOffset);


            let xOffset = itemOffset[app.appointmentId] || 0;
            let count = Object.keys(itemOffset).length || 1;


            let pos = this.getPosFromDate(app.start);
            let posEnd = this.getPosFromDate(app.end);


            let bounds = {};
            let w = this.colSegs / count;

            bounds.x = pos[1] + (xOffset * w);
            bounds.y = pos[0];
            bounds.h = posEnd[0] - pos[0];
            bounds.w = w;


            items[app.appointmentId] = {
                item: <CalendarAppointment id={app.appointmentId} appointment={app} grid={this} onSelect={this.props.onAppointmentSelect}/>,
                bounds: [bounds.x, bounds.y, bounds.w, bounds.h],
                appointment: app,
                allowResize: true,
                draggable: true
            }

            /*
            items.push(
                <div key={gridData.i} data-grid={gridData}>
                    <AppCalendarCell  id={gridData.i} appointment={app} grid={this} onUpdateApp={this.handleUpdateApp} onSelect={this.props.onAppointmentSelect} />
                </div>
            )*/
        }

        return items;
    }

    __handleGridItemDrop = (item, bounds, itemId, eventName, touchEvent) => {
        console.log('~~~~ Item Drop ~~~~', item, 'Bounds:', bounds);
        if(item)this.handleUpdateApp(item.appointment, bounds);
    }


    handleUpdateApp(app, bounds, isUndo = false){
        console.log('handleUpdateApp')
        if(this.state.isBusy)return;
        const undo = {
            app: app,
            start: app.start,
            end: app.end
        };
        //JSON.parse(JSON.stringify(app));
        if(!isUndo){
            const pos = {
                x: bounds[0],
                y: bounds[1],
                w: bounds[2],
                h: bounds[3]
            }

            //let app = JSON.parse(JSON.stringify(appointment));

            //console.log("Handle Update:", pos)

            let start = this.getDateFromPos(pos.x, pos.y);// this.getTimeFromRow(pos.y);
            let end = this.getDateFromPos(pos.x, pos.y + pos.h);


            app.start = start.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
            app.end = end.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)

            console.log("start:", app.start , "  end:", app.end)

            if(!AppointmentService.IsValidAppTime(app)){

                NotificationManager.error('This action will place the appointment outside of pedorthists hours.');
                //this.forceUpdate();

                // return;// Promise.resolve(appointment);
            }
        }


        let appserv = new AppointmentService();

        this.setState({isBusy:true});
        return appserv.createApp(app).then((d) => {
            console.log("Appointment Updated:", d);
            if(!isUndo){
                NotificationManager.success(
                    <div>
                            <span className='app-undo-btn' onClick={()=>{
                                const undoApp = undo.app;
                                undoApp.start = undo.start;
                                undoApp.end = undo.end;
                                this.handleUpdateApp(undoApp, bounds, true)
                            }}>UNDO
                            </span>
                        <div className='notification-close-btn'>x</div>
                    </div>

                    , 'Appointment Updated!', 5000
                );
            } else {
                if(this.props.refresh){
                    console.log('Refreshing Apps')
                    this.props.refresh();
                }
            }



            this.setState({isBusy:false})
            return app;
        })
    }

    onEmptyCellClick = (row, col) => {
        if(this.props.onCreateAppointment){
            let date = this.getDateFromPos(col, row);
            this.props.onCreateAppointment({
                start: date.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS),
                end: date.add(30, 'minutes').format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
            })
        }
    }

    hiddenStuff(){
        console.log("*** Grid Active Matrix:", this.gridActiveMatrix);
        let style = this.generateActiveCellStyle().join("\n");
        let today = moment();
        let isThisWeek = moment(this.props.date).format('YYYY-w') == today.format('YYYY-w');
        let todayStyle = '';
        let day = today.day();
        if(isThisWeek){
            todayStyle = `
            .grid-view [col="` + day +`"]{                
                border-left: solid 1px rgba(0,0,255,0.2);
                border-right: solid 1px rgba(0,0,255,0.2);
            }`;
        }

        return <style dangerouslySetInnerHTML={ {__html: todayStyle + style}} />
    }

    generateActiveCellStyle(){
        let activeMatrix = this.gridActiveMatrix;
        let segsPerRow = this.colSegs;
        let style = [];
        for(let day = 0; day < activeMatrix.length; day++){
            let segments = activeMatrix[day];
            for(let i=0; i < segments.length; i++){
                let segment = segments[i];
                let row = parseInt(segment / segsPerRow, 10);
                let subSeg = 1 + (segment % segsPerRow);
                let s = `.grid-view [col="` + day +`"][row="` + row +`"] > div >:nth-child(` + subSeg + `){
                            background-color: #fff;
                            cursor: cell;
                            pointer-events: all;
                        }`;
                style.push(s);
            }
        }

        //console.log('@@@@@@ ActiveSell Style: ', style);df
        return style;
    }

    getScheduleItems(){

        let activeMatrix = this.gridActiveMatrix;
        let segsPerRow = this.colSegs;
        let items = {};

        console.log('Active Matrix:', activeMatrix);

        for(let day = 0; day < activeMatrix.length; day++){
            let segments = activeMatrix[day];

            if(segments.length < 2)continue;

            const dayStart = segments[0];
            const dayEnd = segments[1] - dayStart;



            items[`active-cell-${day}`] = {
                item:'',
                bounds:[day * segsPerRow, dayStart, segsPerRow, dayEnd],
                className: 'active-cell',
                static: false,
                draggable: false
            }


            /*for(let i=0; i < segments.length; i++){
                let segment = segments[i];
                let row = parseInt(segment / segsPerRow, 10);
                let subSeg = 1 + (segment % segsPerRow);
                let s = `.grid-view [col="` + day +`"][row="` + row +`"] > div >:nth-child(` + subSeg + `){
                            background-color: #fff;
                            cursor: cell;
                            pointer-events: all;
                        }`;

            }*/
        }
        console.log('*%* Scheduled ITems:',items );
        return items;
    }

   /* componentWillUnmount() {
        ExtAppService.RemoveListener('calendar-week-view');
    }

    componentDidMount() {
        ExtAppService.AddListener('calendar-week-view', (extapps) => {
            this.setState({externalApps: this.bcAppsToItems(extapps)})
        })
    }*/

    getBCItems() {
        return this.bcAppsToItems(this.props.bcApps);
    }

    bcAppsToItems(bcapps) {
        // console.log("Conflict Apps:", apps);

        //let weekRange = moment(this.props.date);
        const weekStart = moment(this.props.date).day(0);
        const weekEnd = moment(this.props.date).day(6);


        const apps = (bcapps || []).filter( app => {
            const start = moment(app.startDate);
            return (app.biopedUserId === this.props.doctorId) && (start.isBetween(weekStart, weekEnd, undefined, '[]'));
        });

        let items = [];

        for(let i=0; i < apps.length; i++){
            let app = ExtAppToIntApp(apps[i]);

          /*  let itemOffset = ParseConflicts(app);
            //console.log("ParseConflicts:", itemOffset);


            let xOffset = itemOffset[app.appointmentId] || 0;
            let count = Object.keys(itemOffset).length || 1;*/

            let xOffset = 0;

            let pos = this.getPosFromDate(app.start);
            let posEnd = this.getPosFromDate(app.end);


            let bounds = {};
            let w = this.colSegs;// / count;

            bounds.x = pos[1] + (xOffset * w);
            bounds.y = pos[0];
            bounds.h = posEnd[0] - pos[0];
            bounds.w = w;


            items[app.externalAppointmentId] = {
                item: <BCCalendarAppointmentCell id={app.externalAppointmentId} appointment={app} grid={this} onSelect={this.props.onAppointmentSelect}/>,
                bounds: [bounds.x, bounds.y, bounds.w, bounds.h],
                appointment: app,
                allowResize: false,
                draggable: false
            }
        }
        return items;
    }


}



// WEBPACK FOOTER //
// ./src/views/CalendarWeekView.js